import { createSelector } from 'reselect';

export const jobsSelector = (state) => state.jobs;

export const currentJobSelector = createSelector(jobsSelector, (state) => state.currentJob);
export const jobsFoundSelector = (state) => state.jobs.found;
export const jobsInitializedSelector = (state) => state.jobs.initialized;
export const jobsLoadingSelector = (state) => state.jobs.loading;
export const jobApplicationSubmitSelector = (state) => state.jobApplication;
